import * as firebase from "firebase";
import users from './store/user'
import {browserHistory} from 'react-router';
import cryptojs from 'crypto-js';
import define from './define';

firebase.initializeApp(define.FIREBASE_CONFIG);
var provider = new firebase.auth.FacebookAuthProvider();
const disabledFlg = 'disabled'

export const deleteUserScores = (uid) => {
  return new Promise((resolve, reject) => {
    const ref = firebase.database().ref('scores');
    ref.orderByChild('userid').equalTo(uid).once('value')
      .then(snapshot => {
        let updates = {};
        snapshot.forEach(child => updates[child.key] = null);
        ref.update(updates);
        resolve()
      })
      .catch(() => {
        resolve()
      })
  })
}

export const getIconUrl = (clientId) => {
  return new Promise((resolve, reject) => {
    // クライアントデータ取得
    firebase.database().ref(`oauth_clients/${clientId}`).once('value')
      .then(snapshot => {
        if (!snapshot.val()) {
          // 存在しないOAuthクライアント
          browserHistory.push('/');
          return;
        }
        const client = snapshot.val();
        // アイコンへのフルパスを取得
        return firebase.storage().ref(`oauth_clients/icons/${client.icon_file_name}`).getDownloadURL();
      })
      .then(url => {
        resolve(url);
        return;
      })
      .catch(err => {
        // デフォルトアイコン画像
        resolve('/img/common/m-icon@2x.png');
        return;
      })
    });
}

export const getCurrentEmail = (uid) => {
  return new Promise((resolve, rejct) => {
    firebase.database().ref('users/' + uid + '/email/').once('value')
      .then(email => {
        resolve(email.val())
      })
  })
}

// facebook login for myrate login
export const fbLoginForOauth = () => {
  return new Promise((resolve, reject) => {
    firebase.auth().signInWithPopup(provider)
      .then(result => {
        resolve(result.user.uid)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// email login for myrate login
export const emailLoginForOauth = (email, password) => {
  return new Promise((resolve, reject) => {
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(user => {
        resolve(user.uid)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const getServiceName = (clientId) => {
  return new Promise((resolve, reject) => {
    firebase.database().ref('oauth_clients').orderByChild('client_id').equalTo(clientId).once('value')
      .then(snapshot => {
        if (!snapshot.val()) {
          // 存在しないOAuthクライアント
          browserHistory.push('/');
          return;
        }
        const objectKey = Object.keys(snapshot.val())[0];
        resolve(snapshot.val()[objectKey].service_name)
      })
      .catch(err => {
        reject(err);
      })
  });
}

export const changePassword = (currentPassword, newPassword) => {
  let user;
  let cipher;

  return new Promise((resolve, reject) => {
    const decryptedPass = cryptojs.AES.decrypt(users.getMyUser().password, define.ENV.passwordSecret).toString(cryptojs.enc.Utf8);
    if (decryptedPass !== currentPassword) {
      reject({ code: 'wrong-password'})
      return;
    }

    user = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(
      user.email, 
      currentPassword,
    );
    // パスワード変更前に直近ログインしてる必要があるため一度ログイン
    user.reauthenticateWithCredential(credential)
      .then(() => {
        user.updatePassword(newPassword)
        .then(() => {
          // 新しいパスワードでDB更新
          cipher = cryptojs.AES.encrypt(newPassword, define.ENV.passwordSecret).toString();
          const updates ={}
          updates[`users/${user.uid}/password`] = cipher;
          return firebase.database().ref().update(updates)
        })
        .then(() => {
          // 新しいパスワードを設定
          users.setCurrentUserPass(cipher);
          resolve(true)
          return;
        })
        .catch(err => {
          reject(err)
          return;
        })
      })
      .catch(err => {
        reject({ code: 'wrong-password' })
        return;
      })
    })
}

export const getUserId = callback => {
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      callback(user["uid"]);
    } else {
      callback()
    }
  });
}

export const onLogin = (callback, push = true) => {
  firebase.auth().onAuthStateChanged(function(user) {
    if (!user) {
      if (true === push) {
        // サインインしていない状態ならばログインページに飛ばす
        browserHistory.push("/lpLogin");
      } else {        
        callback(false)
      }
    } else {
      // サインインしている状態
      firebase.database().ref('users/' + user.uid).on('value',function(snapshot) {
        var userdata = snapshot.val();
        if (userdata) {
          // 本登録が済んだユーザーか
          if ("true" === userdata.registComplete) {
            users.setCurrentUser(userdata)
            callback(true)
          } else {
            // 本登録が済んでいない状態ならば登録ページに飛ばす
            browserHistory.push("/newflow1");
          }
        } else {
          // 本登録が済んでいない状態ならば登録ページに飛ばす
          browserHistory.push("/newflow1");
        }
      });
    }
  });
}

export const onLoginForHeader = (callback) => {
  firebase.auth().onAuthStateChanged(user => {
    if (!user) {
      if(callback) callback(false)
    } else {
      // サインインしている状態
      firebase.database().ref('users/' + user.uid).on('value',function(snapshot) {
        var userdata = snapshot.val();
        if (userdata) {
          // 本登録が済んだユーザーか
          if ("true" === userdata.registComplete) {
            users.setCurrentUser(userdata)
            if(callback) callback(true)
          } else {
            // 本登録が済んでいない状態
            if(callback) callback(false)
          }
        } else {
          // 本登録が済んでいない状態
          if(callback) callback(false)
        }
      });
    }
  });
}

export const checkLogin = (isCallback, callback) => {
  firebase.auth().onAuthStateChanged(function(user) {
    if (!user) {
      // サインインしていない状態ならば何もしない
    } else {
      // サインインしている状態
      firebase.database().ref('users/' + user.uid).on('value',function(snapshot) {
        // DBにも値がある状態
        if (null !== snapshot.val()) {
          users.setCurrentUser(snapshot.val())
          // 登録も完全に完了している場合
          if ("true" === snapshot.val().registComplete) {
            if (true === isCallback) {
              callback(true)
            } else {
              browserHistory.push("/user/" + users.getMyUser().uid);
            }
          }
        }
      });
      if (true !== isCallback) {
        if(callback) callback(true)
      }
    }
  });
}

export const onLogout = (callback)=>{
  firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
    } else {
      callback()
    }
  });
}

export const logout = ()=>{
  firebase.auth().signOut()
}


// ユーザー情報登録用
export const Facebookregister = (value, callback) => {
  //FB認証時（newflow1）emailが取得できなかった場合のフラグ
  let noEmail = false
  if ("" !== value.email && null !== value.email && "undefined" !== typeof value.email) {
    firebase.database().ref('users/' + users.getMyUser().uid + '/email/').set(value.email);
  } else {
    noEmail = true
  }
  if ("" !== value.photoURL && null !== value.photoURL && "undefined" !== typeof value.photoURL) {
    firebase.database().ref('users/' + users.getMyUser().uid + '/photoURL/').set(value.photoURL);
  }
  firebase.database().ref('users/' + users.getMyUser().uid + '/displayName/').set(value.displayName);
  firebase.database().ref('users/' + users.getMyUser().uid + '/uid/').set(value.uid);
  firebase.database().ref('users/' + users.getMyUser().uid + '/facebookId/').set(value.facebookId);
  callback(noEmail);
}
// 引数不要
export const phoneNumberregister = (value)=>{
  //firebase.database().ref('users/' + users.getMyUser().uid + '/phoneNumber/').set(value);
  firebase.database().ref('users/' + users.getMyUser().uid + '/phoneNumber/').set("Check done");
}
// つかわれてない
export const phoneNumberrCheckegister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/phoneNumberCheck/').set(value);
}
export const Canvasregister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/canvasImgURL/').set(value);
}
export const realNameRegister = (value) => {
  firebase.database().ref('users/' + users.getMyUser().uid + '/realName/').set(value);
}
export const nickNameRegister = (value) => {
  firebase.database().ref('users/' + users.getMyUser().uid + '/displayName/').set(value);
}
export const TrustdockTokenregister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockToken/').set(value);
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockResult/').set("waiting");
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockId/').set(null);  
}
export const termsCheckregister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/termsCheck/').set(value);
}
export const TrustdockIDregister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockResult/').set('waiting');
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockId/').set(value);
}
export const TrustdockResultregister = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockResult/').set(value);
}
export const registComplete = (value)=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/registComplete/').set(value);
}
export const registCertificationCode = (uid, value)=>{
  firebase.database().ref('users/' + uid + '/certificationCode/').push().set({
    certificationCode: value.code,
    cid: value.cid,
    created_at: value.created_at
  });
}
//email変更時、入力された新しいemailを一時保管
export const setTempNewEmail = (value) => {
  firebase.database().ref('users/' + users.getMyUser().uid + '/tempNewEmail/').set(value);  
}
//email変更時、入力された新しいemailを一時保管されたemailを取得しcallbackに渡す
export const getTempNewEmail = (callback) => {
  firebase.database().ref('users/' + users.getMyUser().uid).once('value').then((snapshot) => {
    if(snapshot.val().tempNewEmail) {
      callback(snapshot.val().tempNewEmail)
    }
  })  
}

//email更新
export const updateEmail = (value, id) => {
  const userId = id ? id : users.getMyUser().uid;
  firebase.database().ref('users/' + userId + '/email/').set(value);
}
//名前とメッセージ更新
export const updateProfile = (value)=>{
  //firebase.database().ref('users/' + users.getMyUser().uid + '/email/').set(value.email);
  firebase.database().ref('users/' + users.getMyUser().uid + '/displayName/').set(value.displayName);
  firebase.database().ref('users/' + users.getMyUser().uid + '/realName/').set(value.realName);
  firebase.database().ref('users/' + users.getMyUser().uid + '/bio/').set(value.bio);
}

//名前変更後のユーザーのtrustdockデータ　reupload
export const statusIdReupload = ()=>{
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockId/').set(null);
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockResult/').set("reupload");
  firebase.database().ref('users/' + users.getMyUser().uid + '/trustdockToken/').set(null);
}

// LP登録用
export const preUserregister = (value)=>{
  firebase.database().ref('preusers/').push().set({
    email: value
  });
}


export const identificationImgURLregister = (value)=>{
  firebase.database().ref('identificationImgURL/').set({
    value: value
  });
}


export const upload = (e,cb)=>{

  var file = e.target.files[0];
  var ref = firebase.storage().ref('images/' + file.name);

  var metadata = {
    contentType: 'image/png',
  };

  ref.put(file,metadata).then(function(){
    cb();
  });
}


export const canvasUpload = (cb)=>{
  var canvas = document.getElementById('mycanvas');
  var metadata = {
    contentType: 'image/png',
  };


  var message = canvas.toDataURL("image/png");

  var canvasUrl = message.replace( "data:image/png;base64,", "" ) ;
  var ref = firebase.storage().ref('sign/' + (new Date()).getTime() + ".png");

  ref.putString(canvasUrl,'base64' ,metadata).then(function(snapshot) {

      ref.getDownloadURL().then(function(canvasUrl) {
          // inserted into an <img> element:
          var img = document.getElementById('myimg');
          img.src = canvasUrl;
        }).catch(function(error) {

      });
        cb(canvasUrl);
   });
}


export const getUser = (uid,cb)=>{
  firebase.database().ref('/users/' + uid).once('value').then(function(snapshot) {
    cb(snapshot.val())
  });
}

export const getidentificationImgURL = (cb)=>{
  firebase.database().ref('/identificationImgURL/').on('value',function(snapshot) {
    cb(snapshot.val())
  });
}

export const getCertificationCodes = (uid,cb)=>{
  firebase.database().ref('/users/' + uid + '/certificationCode/').once('value').then(function(snapshot) {
    cb(snapshot.val())
  });
}

export const deleteCertificationCode = (uid, id)=>{
  firebase.database().ref('users/' + uid + '/certificationCode/' + id).set({});
}

export const recordCertification = (uid, referrer)=>{
  firebase.database().ref('certifications').push().set({
    uid: uid,
    referrer: referrer
  });
}

export const emailLogin = async (email, password, callback) => {
  try {
    const user = await firebase.auth().signInWithEmailAndPassword(email, password);
    const snapshot = await firebase.database().ref('users/' + user.uid).once('value');
    // update last login
    await firebase.database().ref('users/' + user.uid + '/last_login').set(getNow());
    // 登録フロー未完了　電話番号登録から再登録
    if ("true" !== snapshot.val().registComplete) {
      browserHistory.push('/newflow3');
      return;
    }
    // set user store
    users.setMyUser(snapshot.val(), callback);
  } catch (err) {
    if (err.code) throw err.code;
  }
}
// email/password auth
export const createUserWithEmail = (email, password) => {
  let newUser;
  return new Promise((resolve, reject) => {
    firebase.auth().createUserWithEmailAndPassword(email, password)
      .then(user => {
        newUser = user;
        const cipher = cryptojs.AES.encrypt(password, define.ENV.passwordSecret).toString();
        return Promise.all([
          firebase.database().ref('users/' + newUser.uid + '/uid').set(newUser.uid),
          firebase.database().ref('users/' + newUser.uid + '/email').set(email),
          firebase.database().ref('users/' + newUser.uid + '/password').set(cipher),
          // 登録日時
          firebase.database().ref('users/' + newUser.uid + '/created_at').set(getNow()),
          // ログイン日時
          firebase.database().ref('users/' + newUser.uid + '/last_login').set(getNow()),
        ]);
      })
      .then(() => {
        return firebase.database().ref('users/' + newUser.uid).once('value');
      })
      .then(snapshot => {
        users.setCurrentUser(snapshot.val());
        resolve(true);
      })
      .catch(err => {
        reject(err);
      })
  })
}

// facebook auth
// アカウント登録フローが完了している場合ユーザー画面
// アカウント未登録の場合ユーザーデータ作成
export const login = (callback, isRegist) => {
  // popupを表示(FBログイン)
  firebase.auth().signInWithPopup(provider).then(result => {
    // FBの情報を格納
    var fbuser = result.user.providerData[0];
    // FB(&firebase)から値が帰ってきたら、まずFirebaseのAuth連携
    firebase.auth().onAuthStateChanged(user => {
      // FirebaseAuthから取れたデータでログイン確認
      if(!user) {
        return        
      }
      firebase.database().ref('users/' + user.uid).once('value', snapshot => {
        var users_tmp = snapshot.val();
        var goToRegist = false;
        if(!isRegist && (null == snapshot.val() || typeof users_tmp.registComplete === 'undefined')) {
          // user registering process does not complete
          browserHistory.push({
            pathname:"/",
            state:{
              isUser:false
            }
          })
          return
        }
        if (null == snapshot.val()) {
          goToRegist = true;
        } else if ("true" !== users_tmp.registComplete || null == users_tmp.registComplete) {
          // 本登録が済んでないユーザー
          goToRegist = true;
        }

        if (true === goToRegist) {
          // user does not have an account yet
          // FirebaseAuthから取れたデータを使って、FBユーザーデータをDB登録
          firebase.database().ref('users/' + user.uid + '/uid').set(user.uid);
          firebase.database().ref('users/' + user.uid + '/facebookId').set(fbuser.uid);
          firebase.database().ref('users/' + user.uid + '/photoURL').set(fbuser.photoURL);
          firebase.database().ref('users/' + user.uid + '/email').set(fbuser.email);
          firebase.database().ref('users/' + user.uid + '/displayName').set(fbuser.displayName);

          let registData = getNow()
          //登録日時
          firebase.database().ref('users/' + user.uid + '/created_at').set(registData);
          //ログイン日時
          firebase.database().ref('users/' + user.uid + '/last_login').set(registData);

          fbuser["firebase_uid"] = user.uid;

          // 格納
          users.setOAuthRedirect(fbuser, () => {
            callback()
          });
        } else {
          //user already has myrate account
          //ログイン日時
          firebase.database().ref('users/' + users.getMyUser().uid + '/last_login').set(getNow());          
          browserHistory.push("/user/" + users.getMyUser().uid);
        }
      });
    });
      
  }).catch(error => {
      // Handle Errors here.
  });
}

const getNow = () => {
  let now = new Date()
  let format = now.getFullYear() + "-" 
  format += (now.getMonth() + 1)  + "-"
  format += now.getDate() + " "
  format += now.getHours() + ":"
  format += now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
  format +=  ":"
  format += now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
  return format;
}

export const updateProfilePhoto = (path,uid) => {
  firebase.database().ref('users/' + uid + '/updatePhoto').set(path);            
}

export const getUserCount = (getCount,offsetKey,cb) => {
  let result = {}
  let arrTotal = {}
  let arrUser = []
  firebase.database().ref('users').once('value').then((snapshot) => {
    let listCP = snapshot.val()
    let countUser = Object.keys(listCP).length
    firebase.database().ref("points").on("value", function(snapshot){
      let points = snapshot.val();
      firebase.database().ref("partners").on("value", function(PartnerRecord){
        let partners = PartnerRecord.val();
        if(listCP) {
          let iterate = 0;
          let offsetKeyCopy = JSON.parse(JSON.stringify(offsetKey))
          Object.keys(listCP).forEach((key) => {
            let userOne = {}
            let coupon = listCP[key]
            let isTrustdockResult = coupon ? coupon.hasOwnProperty('trustdockResult') : false
            if(iterate === 0 || iterate % getCount === 0) {
              offsetKeyCopy.push(key)
            }
            iterate++
            firebase.database().ref("api_users_eval").orderByChild("uid").equalTo(coupon.uid).once('value').then((snap) => {
              let evalPartner = {}
              evalPartner = getPointEvalUser(snap, partners)
              // ユーザーのスコアデータを取得
              let ref = firebase.database().ref("scores");
              ref.orderByChild("userid").equalTo(coupon.uid).on('value',(scoreRecord) => {
                result = setScoreAndTags(points, scoreRecord, isTrustdockResult, evalPartner.score)
                userOne = evalPartner.data
                userOne.displayName = coupon.displayName
                userOne.email = coupon.email
                userOne.scoreEval = evalPartner.score
                userOne.rank = result.rank_en
                userOne.score = result.score
                arrUser.push(userOne)
              });
            });
          })
          arrTotal = {
            partner: partners,
            count: countUser,
            data: arrUser,
            offsetkey: offsetKeyCopy
          }
          cb(arrTotal)
        }
      })
    })
  })
}

export const getUserList = (getCount,offsetkey,cb) => {
  let ref = firebase.database().ref('users').limitToFirst(getCount + 1)
  if(offsetkey) {
    ref = firebase.database().ref('users').limitToFirst(getCount + 1).startAt(null,offsetkey)
  }
  ref.once('value').then((snapshot) => {
    cb(snapshot.val())
  });
}

//partnerlist
export const getPartnerCount = (cb) => {
  firebase.database().ref('partners').on('value',(snapshot) => {
    cb(snapshot.val())
  })
}

export const getPartnerList = (getCount, offsetkey, cb) => {
  let ref = firebase.database().ref('partners').limitToFirst(getCount + 1)
  if (offsetkey) {
    ref = firebase.database().ref('partners').limitToFirst(getCount + 1).startAt(null, offsetkey)
  }
  ref.once('value')
    .then(snapshot => {
      cb(snapshot.val())
    });
}

// get partner current
export const getPartnerCurrent = (uid, cb) => {
  firebase.database().ref('partners/' + uid).once('value').then((snapshot) => {
    cb(snapshot.val())
  })
}

const getPointEvalUser = (snapshot, partners) => {
  let resultPoint = 0
  let domains = []
  let snap
  let resCombo = {}
  let arrCustom = {}

  if(snapshot) {
    snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
  } else {
    snap = {}
  }

  // get score of user haven't eval
  for(let k in partners) {
    arrCustom[partners[k].site_name] = 0
  }
  var ar = [];
  //連携解除フラグがたっていないオブジェクトのみを抽出
  for(let s in snap){
    if(snap.hasOwnProperty(s)) {
      ar.push(snap[s])
    }
  }

  Object.keys(ar).forEach((key) => {
    if (domains.indexOf(ar[key].partner_id) === -1)　{
      domains.push(ar[key].partner_id)
    }
  })

  //サービスごとにグループ化
  let groups = {}

  let groupingDomains = (domainKey) => {
    groups[domainKey] = []
    Object.keys(ar).forEach((key) => {
      if(ar[key].partner_id === domainKey) {
        groups[domainKey].push(ar[key])
      }
    })
  }

  for(var d in domains) {
    if(domains.hasOwnProperty(d)) {
      groupingDomains(domains[d])
    }
  }

  //グループ毎に最新created_atを抽出し最新をもったオブジェクトをresultとして格納
  Object.keys(groups).forEach((key) => {
    let thisGroupNewestDate = Math.max.apply(null,groups[key].map((g) => {
      let arr = g.created_at.split(/[- :]/)
      return Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
    }))

    for(let i in groups[key]){
      if(groups[key].hasOwnProperty(i)) {
        let arr = groups[key][i].created_at.split(/[- :]/)
        if(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5])) === thisGroupNewestDate) {
          resultPoint += parseInt((groups[key][i].evals[0].value), 10)
          for(let k in partners) {
            if(partners[k].uid === groups[key][i].partner_id) {
              arrCustom[partners[k].site_name] = groups[key][i].evals[0].value
            }
          }
        }
      }
    }
  })
  resCombo = {
    score:resultPoint,
    data: arrCustom
  }
  return resCombo
}

const setScoreAndTags = (points, snapshot, isTrustdockResult, scoreEval) => {
  let snap

  if(snapshot) {
    snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
  } else {
    snap = {}
  }

  let ar = [];
  //連携解除フラグがたっていないオブジェクトのみを抽出
  for(let s in snap){
    if(!snap[s].hasOwnProperty(disabledFlg)) {
      ar.push(snap[s])
    }
  }
  //各サービス最新一件だけを加算対象とする
  //ユーザーに紐づく連携対象ドメイン配列化
  let domains = []
  Object.keys(ar).forEach((key) => {
    if (domains.indexOf(ar[key].domain) === -1)　{
      domains.push(ar[key].domain)
    }
  })

  //サービスごとにグループ化
  let groups = {}

  let groupingDomains = (domainKey) => {
    groups[domainKey] = []
    Object.keys(ar).forEach((key) => {
      if(ar[key].domain === domainKey) {
        groups[domainKey].push(ar[key])
      }
    })
  }

  for(let d in domains) {
    if(domains.hasOwnProperty(d)) {
      groupingDomains(domains[d])
    }
  }

  //グループ毎に最新created_atを抽出し最新をもったオブジェクトをresultとして格納
  let resultArr = []
  Object.keys(groups).forEach((key) => {
    let thisGroupNewestDate = Math.max.apply(null,groups[key].map((g) => {
      let arr = g.created_at.split(/[- :]/)
      return Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
    }))

    for(let i in groups[key]){
      if(groups[key].hasOwnProperty(i)) {
        let arr = groups[key][i].created_at.split(/[- :]/)
        if(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5])) === thisGroupNewestDate) {
          resultArr.push(groups[key][i])
        }
      }

    }
  })

  // スコアデータを数値化
  let score = 0;
  //trustdockに登録していたらポイント加算
  if(isTrustdockResult) {
    for(let i in resultArr) {
      if (resultArr.hasOwnProperty(i)) {
        for(let n in resultArr[i]["tag"]) {
          if (resultArr[i]["tag"].hasOwnProperty(n)) {
            let domain = resultArr[i]["domain"];
            let tag = resultArr[i]["tag"][n];
            if (points[domain][n][tag]) {
              // ポイント表(pointsテーブル)に沿ってスコアを加算
              score += parseInt(points[domain][n][tag], 10);
            }
          }
        }
      }

    }
  }

  if(scoreEval) {
    score += scoreEval;
  }

  switch(true) {
    case score >= 200:
      // Gold(200~)
      return {score: score, rank_en: "Gold"}
    case score >= 100 && score < 200 :
      // Silver(100~200)
      return {score: score, rank_en: "Silver"}
    case score >= 10 && score < 100 :
      // Bronze(10~100)
      return {score: score, rank_en: "Bronze"}
    default:
      // Beginner(0~10)
      return {score: score, rank_en: "Beginner"}
  }
}

// WEBPACK FOOTER //
// ./src/firebase.js


// WEBPACK FOOTER //
// ./src/firebase.js